import React from 'react';
import {
  List,
  Create,
  Datagrid,
  TextField,
  TextInput,
  SelectArrayInput,
  SimpleForm,
  EditButton,
  required,
} from 'react-admin';
import Icon from '@material-ui/icons/VpnKey';
import EditForm from './EditForm';

export const RoleIcon = Icon;

// const ListFilter = props => (
//   <Filter {...props}>
//     <TextInput label="Search" source="f" alwaysOn />
//   </Filter>
// );

const permissionChoices = [
  { id: 'brands', name: 'Car Brand' },
  { id: 'models', name: 'Car Model' },
  { id: 'promotions', name: 'Promotion' },
  { id: 'vouchers', name: 'Voucher' },
];

export const RoleList = props => (
  <List {...props} filters={null}>
    <Datagrid>
      <TextField source="id" label="Role ID" />
      <TextField source="name" />
      <EditButton />
    </Datagrid>
  </List>
);

export const RoleCreate = props => (
  <Create title={'New Role'} {...props}>
    <SimpleForm redirect="list">
      <TextInput source="name" validate={required()} />
      <SelectArrayInput label="Role Permission" choices={permissionChoices} source="permission" />
    </SimpleForm>
  </Create>
);

export const RoleEdit = EditForm;



// WEBPACK FOOTER //
// ./src/containers/Role/index.js